import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'feature-products',
  templateUrl: './feature-product.component.html',
  styleUrls: ['./feature-product.component.scss']
})
export class FeatureProductComponent implements OnInit {
  @Input() featureProd;
  constructor() {}

  ngOnInit() {
    console.log(this.featureProd.products)
    this.featureProd.products[0].displayItems=this.featureProd.products[0].displayItems.filter(item => {
      return item.keyText !== 'Artisan Pollution Liability';
    });
    
    this.featureProd.brochures[0].displayItems=this.featureProd.brochures[0].displayItems.filter(item => {
      return item.keyText !== 'Contractor Pollution Liability';
    });
    window.scrollTo(0, 0);
  }
}
